"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const card_1 = require("primereact/card");
const webCard_module_scss_1 = __importDefault(require("./webCard.module.scss"));
const no_image_png_1 = __importDefault(require("../../../assets/no-image.png"));
const WebCard = ({ title, subTitle, customContent, contentEdit, subtitleEditable, imageSrc, className = 'md:w-25rem', isEditing, footer, header, }) => {
    const [imgSrc, setImgSrc] = (0, react_1.useState)(imageSrc || no_image_png_1.default);
    const handleError = () => {
        setImgSrc(no_image_png_1.default);
    };
    (0, react_1.useEffect)(() => {
        if (imageSrc) {
            setImgSrc(imageSrc);
        }
        else {
            setImgSrc(no_image_png_1.default);
        }
    }, [imageSrc]);
    const genericHeader = ((0, jsx_runtime_1.jsx)("div", { className: 'flex flex-col', children: (0, jsx_runtime_1.jsx)("img", { alt: "Card", src: imgSrc, onError: handleError, className: webCard_module_scss_1.default.cardImage }) }));
    return ((0, jsx_runtime_1.jsx)("div", { className: `card flex justify-content-center ${className} md:w-25rem'`, children: (0, jsx_runtime_1.jsx)(card_1.Card, { "data-testid": "custom-card", className: webCard_module_scss_1.default.card, title: title, subTitle: isEditing ? subtitleEditable : subTitle, footer: footer, header: header || genericHeader, children: (0, jsx_runtime_1.jsx)("div", { className: "m-0", children: isEditing ? ((0, jsx_runtime_1.jsx)("div", { className: webCard_module_scss_1.default.cardContent, children: contentEdit })) : ((0, jsx_runtime_1.jsx)("div", { className: webCard_module_scss_1.default.cardContent, children: customContent })) }) }) }));
};
exports.WebCard = WebCard;
